import { Record } from 'immutable'

import { generateUUID } from 'utils/uuid'

export class DateRecord extends new Record({
  id: undefined,  // uuid
  date: undefined,  // YYYY-MM-DD
}) {
  constructor(date) {
    super({
      id: generateUUID(),
      date,
    })
  }
}

export class TimeRecord extends new Record({
  id: undefined,  // uuid
  hour: undefined,
  minute: undefined,
}) {
  constructor(hour, minute) {
    super({
      id: generateUUID(),
      hour: parseInt(hour, 10),
      minute: parseInt(minute, 10),
    })
  }
}

export class SellableItemRecord extends new Record({
  id: undefined,  // uuid
  serverId: undefined,
  deleted: false,
  updated: false,
  name: undefined,
  quantity: undefined,
  salePrice: undefined,
  faceValue: undefined,
  description: undefined,
  color: undefined,
  ticketIncrement: undefined,
}) {
  constructor({ id, name, quantity, salePrice, faceValue, description, ticketIncrement }, color) {
    super({
      id: generateUUID(),
      serverId: id,
      name,
      description,
      salePrice,
      faceValue,
      color, // local only
      quantity, // local only
      ticketIncrement,
    })
  }
}

export class SellableItemGroupRecord extends new Record({  // eslint-disable-line no-unused-vars
  id: undefined,  // uuid
  serverId: undefined,
  name: undefined,
}) {
  constructor(name) {
    super({
      id: generateUUID(),
      name,
    })
  }
}

export class DealRecord extends new Record({
  id: undefined,  // uuid
  serverId: undefined,
  deleted: false,
  sellableItemId: undefined,
  performanceId: undefined,
  ticketCount: undefined,
  soldTickets: undefined,
  isOnsale: undefined,
  discountPrice: undefined,
  initialPrice: undefined,
}) {
  constructor({ id, ticketCount, performance, soldTickets, isOnsale, discountPrice, initialPrice }, sellableItemId) {
    super({
      id: generateUUID(),
      serverId: id,
      sellableItemId,
      performanceId: performance,
      ticketCount,
      soldTickets,
      isOnsale,
      discountPrice,
      initialPrice,
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/grid/grid-records.js
 **/